var kpiManager = {};

kpiManager = {

  filteredClassLists: document.querySelectorAll('.kpiManager__filtered-class-list'),
  allClasses: document.querySelector('.kpiManager__filtered-class-list-all'),
  morningClasses: document.querySelector('.kpiManager__filtered-class-list-morning'),
  noonClasses: document.querySelector('.kpiManager__filtered-class-list-noon'),
  afternoonClasses: document.querySelector('.kpiManager__filtered-class-list-afternoon'),
  eveningClasses: document.querySelector('.kpiManager__filtered-class-list-evening'),

  init: function () {

    const dropdown = document.querySelector('.kpi-dropdown');
    const datepickerFrom = document.getElementById('kpiManager__datepicker-from');
    const datepickerTo = document.getElementById('kpiManager__datepicker-to');
    const datepickerBtn = document.querySelector('.kpiManager__datepicker-button');
    const filterButtons = document.querySelectorAll('.kpiManager__class-filter');

    if (datepickerFrom && datepickerTo && dropdown && datepickerBtn) {
      datepickerBtn.addEventListener('click', () => {
        datepickerBtn.classList.add('button--loading')
        this.setURL(datepickerFrom, datepickerTo, dropdown)
      })

      dropdown.onchange = () => {
        this.setURL(datepickerFrom, datepickerTo, dropdown)
      }

      const selectClassInput = document.querySelector('.kpi-dropdown-classes')
      const hiddenClassInput = document.getElementById('kpi-email-list-bydate-class')
      if (selectClassInput && hiddenClassInput) {
        selectClassInput.addEventListener('change', () => {
          hiddenClassInput.value = selectClassInput.value
        })
      }
      const emailListDateFrom = document.getElementById('kpi-email-list-bydate-datefrom')
      if (emailListDateFrom) {
        datepickerFrom.addEventListener('change', () => {
          emailListDateFrom.value = datepickerFrom.value
        })
      }
      
      const emailListDateTo = document.getElementById('kpi-email-list-bydate-dateto')
      if (emailListDateTo) {
        datepickerTo.addEventListener('change', () => {
          emailListDateTo.value = datepickerTo.value
        })
      }

      
    }

    if (filterButtons) {
      filterButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.handleFilter(filterButtons, btn))
      })
    }
  },

  setURL(datepickerFrom, datepickerTo, dropdown) {
    window.location = window.location.origin + window.location.pathname + `?dayFrom=${datepickerFrom.value}` + `&dayTo=${datepickerTo.value}` + `&data=${dropdown.value}`
  },

  handleFilter(allButtons, filter) {
    allButtons.forEach((btn) => {
      btn.classList.remove('button--is-active')
    })
    filter.classList.add('button--is-active')

    this.filteredClassLists.forEach((list) => {
      list.classList.add('hide')
    })

    if (filter.classList.contains('kpiManager__filter-all') && this.allClasses) {
      this.allClasses.classList.remove('hide')
    }
    if (filter.classList.contains('kpiManager__filter-morning') && this.morningClasses) {
      this.morningClasses.classList.remove('hide')
    }
    if (filter.classList.contains('kpiManager__filter-noon') && this.noonClasses) {
      this.noonClasses.classList.remove('hide')
    }
    if (filter.classList.contains('kpiManager__filter-afternoon') && this.afternoonClasses) {
      this.afternoonClasses.classList.remove('hide')
    }
    if (filter.classList.contains('kpiManager__filter-evening') && this.eveningClasses) {
      this.eveningClasses.classList.remove('hide')
    }
  }
}

kpiManager.initialize = function () {
  kpiManager.init();
};

module.exports = kpiManager;
